export default __webpack_public_path__ + "imgs/a53ee8418f5d3b6d8847532970bfdec2.png";